var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-between" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn create-project",
                    attrs: { to: "/create-project" }
                  },
                  [_vm._v("Criar novo projeto")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.user
            ? _c("div", { staticClass: "row" }, [
                _vm.projects && _vm.projects.length > 0
                  ? _c(
                      "div",
                      { staticClass: "projects-list" },
                      _vm._l(_vm.projects, function(project) {
                        return _c(
                          "div",
                          {
                            key: project.ProjectId,
                            staticClass: "row project"
                          },
                          [
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "cover" }, [
                                project.Info.image &&
                                project.Info.image.length > 0 &&
                                project.Info.image.search(
                                  "via.placeholder.com"
                                ) == -1
                                  ? _c("img", {
                                      attrs: { src: project.Info.image }
                                    })
                                  : _c("img", {
                                      attrs: {
                                        src:
                                          "https://via.placeholder.com/400x400?text=Sem+Foto"
                                      }
                                    }),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("h2", [
                                    _vm._v(_vm._s(project.Info.title))
                                  ]),
                                  _vm._v(" "),
                                  _vm.hasDonations(project)
                                    ? _c("span", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getDonationsValue(project)
                                            )
                                          )
                                        ]),
                                        _vm._v(
                                          " de " +
                                            _vm._s(
                                              _vm.getDonationsCount(project)
                                            ) +
                                            " doador(es)\n                  "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                    Nenhum valor arrecadado.\n                  "
                                        )
                                      ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "span",
                                  { class: "visibility-" + project.visibility },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getVisibility(project.visibility)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                project.projectUnallowed
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "visibility-unallowed",
                                        on: {
                                          click: function($event) {
                                            return _vm.showAlert(project)
                                          }
                                        }
                                      },
                                      [_vm._v("Rejeitado")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !project.projectUnallowed
                                  ? _c(
                                      "span",
                                      { staticClass: "visibility-allowed" },
                                      [_vm._v("Aprovado")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                project.UserId !== _vm.user.UserId
                                  ? _c("span", { staticClass: "visibility" }, [
                                      _vm._v("Permissão para editar")
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "btn",
                                      attrs: {
                                        to: "/project/manage/" + project.slug
                                      }
                                    },
                                    [_vm._v("Editar Projeto")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "btn",
                                      attrs: {
                                        to:
                                          "/project/manage/" +
                                          project.slug +
                                          "?tab=activities"
                                      }
                                    },
                                    [_vm._v("Adicionar Atividade")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "btn",
                                      attrs: { to: "/project/" + project.slug }
                                    },
                                    [_vm._v("Ver Projeto")]
                                  ),
                                  _vm._v(" "),
                                  project.UserId == _vm.user.UserId
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-danger",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.deleteProject(project)
                                            }
                                          }
                                        },
                                        [_vm._v("Excluir")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn facebook-share",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.facebookShare(project)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("Compartilhe "),
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fab", "facebook"],
                                        size: "lg"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn whatsapp-share",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.whatsappShare(project)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("Compartilhe "),
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fab", "whatsapp"],
                                        size: "lg"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("input", {
                                  staticClass: "share-link",
                                  attrs: {
                                    id: "project-" + project.ProjectId,
                                    type: "text",
                                    readonly: ""
                                  },
                                  domProps: {
                                    value:
                                      "https://click2giv.com/" +
                                      _vm.getShortUrl(project)
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "share-button btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.copyToClipboard(
                                          project.ProjectId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Copiar")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "qr-code",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.downloadQrCode(
                                          "https://click2giv.com/" +
                                            project.slug
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "Clique com o botão direito e salve o QR code como imagem:"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("qrcode", {
                                      attrs: {
                                        value:
                                          "https://click2giv.com/" +
                                          project.slug,
                                        options: { width: 120 }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.projects && _vm.projects.length == 0
                  ? _c("h4", { staticClass: "projects-empty" }, [
                      _vm._v("Você não possui projeto. Que tal criar um? =)")
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading
        ? _c("Loading", {
            attrs: { message: "Aguarde, carregando lista de projetos..." }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("h2", [_vm._v("Meus Projetos")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4140b514", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4140b514","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyProjects.vue
// module id = null
// module chunks = 